var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52734 15.7778C7.52734 11.2215 11.221 7.52783 15.7773 7.52783C20.3337 7.52783 24.0273 11.2215 24.0273 15.7778C24.0273 20.3342 20.3337 24.0278 15.7773 24.0278C11.221 24.0278 7.52734 20.3342 7.52734 15.7778ZM15.7773 6.02783C10.3926 6.02783 6.02734 10.3931 6.02734 15.7778C6.02734 21.1626 10.3926 25.5278 15.7773 25.5278C18.0878 25.5278 20.2105 24.7242 21.8812 23.3812L25.3841 26.8841L26.4447 25.8234L22.9756 22.3542C24.5605 20.6204 25.5273 18.312 25.5273 15.7778C25.5273 10.3931 21.1621 6.02783 15.7773 6.02783Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.cdf6b102f663e7393ddff9c383348aa6.svg";
export { ForwardRef as ReactComponent };